module.exports = __webpack_public_path__ + "img/header-logo.e0fe8ed3.png";